const load = (tag, url) => new Promise((resolve, reject) => {
    tag.onload = () => resolve(undefined);
    tag.onerror = () => reject(new Error(`Loading ${url} failed.`));
    return document.head.appendChild(tag);
});
export default load;
